
import ES from './es';
import EN from './en';

const fraudPrevention = {
    ES,
    EN
};

export default fraudPrevention;
